import clsx from 'clsx';

import { BaseButton, BaseButtonProps } from './BaseButton';

export interface ContainedButtonProps extends BaseButtonProps {
  color?: 'primary' | 'secondary' | 'danger';
}

export function ContainedButton(props: ContainedButtonProps) {
  const { className, children, color = 'primary', ...rest } = props;
  const isPrimary = color === 'primary';
  const isSecondary = color === 'secondary';
  const isDanger = color === 'danger';

  const baseClassList = [
    'button-shadow',
    'font-size-[15px]',
    'font-weight-[600]',
    'px-[16px]',
    'disabled:bg-[#e0e0e0]',
    'disabled:text-[#a6a6a6]',
    'disabled:border-[#a6a6a6]',
    'rounded-[50px]'
  ];

  const colorClass = {
    'border border-transparent bg-primary-button text-primary-button-text hover:brightness-95':
      isPrimary,
    'border border-secondary-button-text bg-secondary-button text-secondary-button-text hover:brightness-95':
      isSecondary,
    'bg-blush': isDanger,
    'text-on-primary': isDanger
  };

  return (
    <BaseButton
      className={clsx(baseClassList, colorClass, className)}
      {...rest}
    >
      {children}
    </BaseButton>
  );
}
